import React, { ComponentType } from 'react';
import { Stack, StackProps } from '@cp/ds/src/components/stack';
import { ClientPhotoCard } from '@cp/entities/clientPhoto';
import { Typography } from '@cp/ds/src/components/typography';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { styled } from '@cp/ds/src/theme';
import { BoxProps } from '../../../../../../packages/ds/src/components/box';

export interface AuthorProps extends StackProps {
  data: CatalogItemViewModel;
}

const Root = styled(Stack, { name: 'Vacancy', label: 'author' })({ alignItems: 'center' }) as unknown as ComponentType<BoxProps>;

export const Author: React.FC<AuthorProps> = ({ data, ...props }) => {
  const name = [data.clientProfile?.name, data.clientProfile?.patronymic].filter(Boolean).join(' ');

  return (
    <Root direction="row" {...props}>
      <ClientPhotoCard data={data.clientProfile} size={36} />
      <Typography sx={{ color: 'gray', ml: 1.5 }} variant="body">
        Объявление от: {name}
      </Typography>
    </Root>
  );
};
